// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__N3CYo","code":"NotFoundPage_code__OliyG","title":"NotFoundPage_title__q392v","desc":"NotFoundPage_desc__-oIhC","btn":"NotFoundPage_btn__oQwSz"};